import styled from 'styled-components'

export const Sold = styled.div`
    font-weight: 700;
    font-size: 20px;
    text-transform: uppercase;
    color: #2E2D37;
    background-color: #ECEDF2;
    display: flex;
    align-items: center;
    height: inherit;
    justify-content: center;
`
